import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';

export default function GoldServices() {
  return (
    <div className="min-h-screen" dir="rtl">
      <Header />
      
      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center text-sm text-gray-600">
            <Link to="/" className="hover:text-[#E71B25] transition-colors">
              الرئيسية
            </Link>
            <i className="ri-arrow-left-s-line mx-2"></i>
            <Link to="/services" className="hover:text-[#E71B25] transition-colors">
              الخدمات
            </Link>
            <i className="ri-arrow-left-s-line mx-2"></i>
            <span className="text-[#595A5C] font-medium">الذهب</span>
          </nav>
        </div>
      </div>

      <main className="py-20">
        <div className="container mx-auto px-4">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-[#595A5C] mb-6">تجارة الذهب والمعادن النفيسة</h1>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              نختص في تجارة الذهب والمعادن النفيسة بأعلى معايير الجودة السويسرية، 
              مع الالتزام الكامل بقوانين مكافحة غسل الأموال والشفافية
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20">
            {/* Service Image */}
            <div className="order-2 lg:order-1">
              <img
                src="https://public.readdy.ai/ai/img_res/d6256541c20495d7f38f5fa9f67316ab.jpg"
                alt="تجارة الذهب والمعادن النفيسة"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>

            {/* Service Content */}
            <div className="order-1 lg:order-2">
              <h2 className="text-3xl font-bold text-[#595A5C] mb-8">نطاق خدماتنا</h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">تجارة السبائك الذهبية</h3>
                    <p className="text-gray-600">تجارة سبائك الذهب عالية النقاوة بشهادات معتمدة دولياً</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">ذهب Dore وخدمات الصهر</h3>
                    <p className="text-gray-600">تجارة ذهب Dore وخدمات الفحص والصهر بالمعايير السويسرية</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">شفافية سلسلة التوريد</h3>
                    <p className="text-gray-600">ضمان الشفافية الكاملة في سلسلة التوريد وتتبع مصادر المعادن</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">فحص وتقييم المعادن</h3>
                    <p className="text-gray-600">خدمات فحص وتقييم شاملة للمعادن النفيسة بأحدث التقنيات</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">الاستشارات الاستثمارية</h3>
                    <p className="text-gray-600">استشارات متخصصة للاستثمار في المعادن النفيسة</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Standards Section */}
          <div className="bg-gray-50 rounded-2xl p-12 mb-20">
            <h2 className="text-3xl font-bold text-[#595A5C] mb-8 text-center">معايير الامتثال والشفافية</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">معايير KYC/AML</h3>
                <p className="text-gray-600">الالتزام الكامل بقوانين مكافحة غسل الأموال ومعرفة العميل</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-medal-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">معايير سويسرية</h3>
                <p className="text-gray-600">فحص وصهر المعادن وفق أعلى المعايير السويسرية للجودة</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-shield-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">شهادات معتمدة</h3>
                <p className="text-gray-600">جميع معاملاتنا مدعومة بشهادات دولية معتمدة</p>
              </div>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="mb-20">
            <h2 className="text-3xl font-bold text-[#595A5C] mb-12 text-center">لماذا فيبا للتجارة؟</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-vip-crown-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">جودة استثنائية</h3>
                <p className="text-gray-600">نتعامل فقط مع المعادن النفيسة عالية الجودة والنقاوة المضمونة</p>
              </div>
              
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-shield-user-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">أمان وثقة</h3>
                <p className="text-gray-600">التزام كامل بأعلى معايير الأمان والشفافية في جميع المعاملات</p>
              </div>
              
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-exchange-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">مرونة في التعامل</h3>
                <p className="text-gray-600">حلول مرنة ومخصصة تناسب احتياجات العملاء المتنوعة</p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center bg-[#E71B25] text-white p-12 rounded-2xl">
            <h2 className="text-3xl font-bold mb-6">مهتم بتجارة المعادن النفيسة؟</h2>
            <p className="text-xl mb-8 opacity-90">
              تواصل معنا للحصول على استشارة متخصصة وعرض سعر لاحتياجاتك في المعادن النفيسة
            </p>
            <Button 
              variant="outline" 
              size="lg" 
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#E71B25] whitespace-nowrap"
              onClick={() => window.location.href = 'mailto:info@vipatradingco.com'}
            >
              طلب عرض سعر
              <i className="ri-mail-line mr-2"></i>
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}